import { createContext } from "react";
import { Image, ProjectWithDesigns } from "../../types";

interface ProjectContextType {
  project?: ProjectWithDesigns;
  isProjectLoading?: boolean;
  projectId?: string;
  teamProjectsLoaded?: boolean;
  refetchProject: (options?: { skipLoading?: boolean }) => Promise<void>;
  clearProject: () => void;
  updateProjectDesignImages: (designId: string, images: Image[]) => void;
}

export const ProjectContext = createContext<ProjectContextType>({
  project: undefined,
  projectId: undefined,
  teamProjectsLoaded: false,
  refetchProject: () => Promise.resolve(),
  clearProject: () => {},
  updateProjectDesignImages: () => {},
});
